import { render } from "./BonusInquiry.vue?vue&type=template&id=139ca438&scoped=true"
import script from "./BonusInquiry.vue?vue&type=script&lang=js"
export * from "./BonusInquiry.vue?vue&type=script&lang=js"

import "./BonusInquiry.vue?vue&type=style&index=0&id=139ca438&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139ca438"]])

export default __exports__